import uniqueId from '@form-create/utils/lib/unique';
import { makeRequiredRule } from '../../utils';
var label = '省市区';
var name = 'city';
export default {
  icon: 'iconfont iconshengshiqu',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      props: {
        titleIpt: '省市区'
      },
      title: '',
      input: false,
      info: '',
      effect: {
        required: 'city'
      }
    };
  },
  props: function props() {
    return [{
      type: 'input',
      field: 'titleIpt',
      title: '标识名',
      value: '省市区'
    }, makeRequiredRule()];
  },
  basic: function basic() {}
};